// Название культуры. Две культуры с одним названием смешивают цифры в итогах и в колонках остатков,
// поэтому форма проверяет повтор сразу; последнее слово за сервером (services/main, helpers/cropName.js).

// Пробелы по краям и двойные пробелы внутри другого названия не делают.
export const squashName = (value) => String(value === undefined || value === null ? '' : value).replace(/\s+/g, ' ').trim();

// То же название, без учёта регистра и пробелов.
export const sameCropName = (a, b) => squashName(a).toLowerCase() === squashName(b).toLowerCase();

// Что не так с названием (пустая строка, если всё в порядке). existing: список культур из store,
// пока он не загрузился, повтор ловит сервер.
export const cropNameError = (name, existing) => {
  if (!squashName(name)) return 'Введите название культуры.';
  if ((existing || []).some((crop) => sameCropName(crop.name, name))) return 'Такая культура уже есть';
  return '';
};
